import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Globals } from '../../globals';

@Component({
    selector: 'app-pages',
    templateUrl: './pages.component.html',
    styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit  {
    public item = [];
    public connect;
    public token: any = {
        getpageslink: 'api/getdetailpagesbylink'
    }
    constructor( public route: ActivatedRoute, public globals: Globals,) {
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "pagesdetail":
                    this.item = res.data;
                    setTimeout(() => {
                        if (window["twentytwenty"]) {
                            window["twentytwenty"]();
                        } 
                    }, 50);
                    break;
                default:
                    break;
            }
        })
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            let link = params.link;
            this.globals.send({ path: this.token.getpageslink, token: "pagesdetail", params: { link: link } });
        })
        
    }
    ngOnDestroy(){
        this.connect.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/app/frontend/pages/pages.component.ts